import styled from "styled-components";

export const Wrapper = styled.div`
  h4 {
    color: var(--text-color);
  }
`;
